import type { ReactNode } from "react"

import { ErrorBoundary } from "@sentry/react"

import { Button } from "./button"

export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrorBoundary fallback={<RouteCrashFallback />}>{children}</ErrorBoundary>
}

function RouteCrashFallback() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <div className="text-lg font-medium">
        Something went wrong while loading this page.
      </div>
      <div className="text-muted-foreground text-sm">
        A fresh copy of the app may fix it — try reloading.
      </div>
      <Button onClick={()=> window.location.reload()} variant="destructive">
        Reload
      </Button>
    </div>
  )
}
